const SHOW_ONLY_MY_BILLING_ORGS_STORAGE_KEY = 'deviceInvoices.showOnlyMyBillingOrgs';

export const getShowOnlyMyBillingOrgsPreference = hasBillingOrgScope => {
  if (!hasBillingOrgScope) {
    return false;
  }

  try {
    const storedValue = window.localStorage.getItem(SHOW_ONLY_MY_BILLING_ORGS_STORAGE_KEY);
    if (storedValue === null) {
      return true;
    }
    return storedValue === 'true';
  } catch (error) {
    return true;
  }
};

export const setShowOnlyMyBillingOrgsPreference = value => {
  try {
    window.localStorage.setItem(SHOW_ONLY_MY_BILLING_ORGS_STORAGE_KEY, String(Boolean(value)));
  } catch (error) {
    // Ignore storage failures and keep the in-memory preference.
  }
};
